<template>
  <div id="misc">
    <div class="page-title text-center px-5">
      <h2 class="text-2xl font-weight-semibold text--primary d-flex align-center justify-center">
        <v-icon color="warning" class="mr-2">
          {{ icons.mdiAlert }}
        </v-icon>
        <span class="me-2">Page Not Found</span>
      </h2>

      <v-btn depressed color="primary" to="/" class="mb-4 mt-4">
        Back to home
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiAlert } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlert,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>
